export default "__VITE_ASSET__ylkpyjV6__"